import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { LocalStorageKeys } from '../enums/LocalStorageKeys';
import { TranslateService } from '@ngx-translate/core';
import { PublicRequestService } from 'src/app/services/public-request.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router, private translateService: TranslateService, private PublicRequestService: PublicRequestService) { }

  canActivate(): boolean {
    if (this.PublicRequestService.isPublicRoute() || (this.authService.isLoggedIn() && !this.isSessionExpired())) return true;

    this.throwLogout()
    return false;
  }

  isSessionExpired(): boolean {
    const tokenExpiration = localStorage.getItem(LocalStorageKeys.TokenExpiration);
    if (!tokenExpiration) return true;
    const isoDate = tokenExpiration;
    const timestamp = new Date(isoDate).getTime();
    return Date.now() > timestamp;
  }

  throwLogout() {
    alert(this.translateService.instant('SESSION_EXPIRED'));
    setTimeout(() => {
      this.authService.logout();
    }, 0);
  }
}
